exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Placeholders-List-Item {\n  margin: 1rem;\n  background-color: #f2f5fe;\n  padding: 1rem;\n  text-align: center;\n  font-size: 14px;\n  border: 2px dashed #e4e4e4;\n  border-radius: 6px;\n  font-weight: 500; }\n  .Placeholders-List-Item span {\n    display: block;\n    font-size: 12px;\n    font-weight: 400; }\n", ""]);

// exports
